




































import { plainToInstance } from 'class-transformer'
import Vue from 'vue'
import { Component, VModel } from 'vue-property-decorator'

import SwitchInput from '../../../../../../../../../../Pi/fields/SwitchInput/SwitchInput.vue'
import HasLabelCondition from '../../../../logic/ConditionTypes/LabelConditions/HasLabelConditions'
import HasNotLabelCondition from '../../../../logic/ConditionTypes/LabelConditions/HasNotLabelCondition'
import LabelCondition from '../../../../logic/ConditionTypes/LabelConditions/LabelCondition'
import { ConditionType } from '../../../../logic/types'

@Component({
  data() {
    return {
      ConditionType
    }
  },
  components: {
    SwitchInput,
  }
})
export default class LabelConditionParams extends Vue {
  @VModel() condition!: LabelCondition

  toggleConditionType(conditionType: ConditionType.HasLabel | ConditionType.HasNotLabel) {
    const labelIndex = this.condition.label_index;

    if (conditionType === ConditionType.HasLabel) {
      this.condition = plainToInstance(HasLabelCondition, {
        type: ConditionType.HasLabel,
        label_index: labelIndex,
      })
    } else {
      this.condition = plainToInstance(HasNotLabelCondition, {
        type: ConditionType.HasNotLabel,
        label_index: labelIndex,
      })
    }
  }
}
